<template>
  <div>
    <div class="row">
      <div class="col-4">
        <select class="form-control form-control-sm" @change="selected" v-model="val">
          <option value="UNWORKED">Üzerine Hiç Çalışılmadı</option>
          <option value="APPLYING">Uygulanıyor</option>
          <option value="NOT_APPLYING">Uygulanmıyor</option>
          <option value="REJECTED">Reddedildi</option>
          <option value="PERIODIC_APPROVAL">Periyodik Kontrol Aşamasında</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import AutoCompleteSelect from "./AutoCompleteSelect";
import { methods } from "./commons";

export default {
  props: ["value"],

  components: { AutoCompleteSelect },
  computed: {
    val: {
      get() {
        return this.value ? this.value.value : undefined;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          value,
        });
      },
    },
  },

  methods,
};
</script>
